<template>
  <div class="onboarding-image-template">
    <div class="onboarding-image-template__image-box">
      <img
        class="onboarding-image-template__template-image"
        :src="dashboardImage"
      >
    </div>
    <div class="onboarding-image-template__button-panel">
      <p class="onboarding-image-template__message">
        {{ $t('components.Onboarding.label.title.exploreMessage') }}
      </p>
      <div class="onboarding-image-template__buttons">
        <button
          class="onboarding-image-template__button"
          @click="toggleModal()"
        >
          <img :src="maximize">
        </button>
        <DsModal
          :open="open"
          :full-screen="true"
          :secondary-button-label="closeModal"
          @secondary="toggleModal"
        >
          <template slot="content">
            <img
              class="onboarding-image-template__modal-image"
              :src="dashboardImage"
            >
          </template>
        </DsModal>
      </div>
    </div>
  </div>
</template>

<script>

import { DsModal } from '@ds/components';
import maximizeIcon from '@/assets/icons/maximize.svg';

export default {
  name: 'OnboardingImageTemplate',
  components: {
    DsModal,
  },
  props: {
    dashboardImage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      maximize: maximizeIcon,
      open: false,
      closeModal: `${this.$t('components.Onboarding.label.title.closeMessage')}`,
    };
  },
  methods: {
    toggleModal() {
      this.open = !this.open;
      this.hiddenOnboardingTopBar();
    },
    hiddenOnboardingTopBar() {
      const topBar = document.getElementsByClassName('onboarding-bar')[0];
      if (this.open) {
        topBar.style.zIndex = 0;
      } else {
        topBar.style.zIndex = 'var(--zindex-1)';
      }
    },
  },

};
</script>

<style lang="scss" scoped>
  .onboarding-image-template {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: column;
    width: 364px;
    height: 244px;
    margin-left: var(--ds-spacing-stack-xs);
    background: var(--ds-color-silver);
    border-radius: var(--ds-border-radius-md);
    border: var(--ds-border-width-hairline) solid var(--ds-color-gray-3);

    &__image-box {
      margin: var(--ds-spacing-stack-xs) var(--ds-spacing-stack-xs) 0 var(--ds-spacing-stack-xs);
      max-width: 332px;
      overflow: hidden;
    }

    &__template-image {
      width: 100%;
    }

    &__button-panel {
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 364px;
      height: 48px;
      background: var(--ds-color-background);
      border: var(--ds-border-width-hairline) solid var(--ds-color-gray-3);
      border-radius: 0 0 var(--ds-border-radius-md) var(--ds-border-radius-md);
    }

    &__message {
      margin: var(--ds-spacing-stack-xs);
      font-weight: var(--ds-font-weight-semibold);
      font-size: var(--ds-font-size-xs);
      line-height: var(--ds-font-line-height-dense);
    }

    &__buttons {
      display: flex;
      margin-right: var(--ds-spacing-stack-xs);
    }

    &__button {
      width: var(--ds-spacing-stack-md);
      height: var(--ds-spacing-stack-md);
      border-radius: var(--ds-border-radius-pill);
      transition: 0.3s;

      &:hover {
        cursor: pointer;
        background: var(--ds-color-secondary-button-hover);
      }
    }

    &__modal-image {
      width: 100%;
      margin-bottom: var(--ds-spacing-stack-xs);
    }
  }

  ::v-deep {
    .ds-modal {
      &__slot-content,
      &__content,
      &__container,
      &__header {
        padding: 0;
        margin: 0;
      }

      &__footer {
        height: 88px;
        z-index: var(--zindex-1);
        box-shadow: var(--ds-light-dropshadow-2);
      }
    }
  }
</style>
